import React from 'react'
import Grid from '@mui/material/Grid'
import PropTypes from 'prop-types'
import { useFormState } from 'react-final-form'

import Container, { Content, Header } from '~/components/Container'
import PageTitle from '~/components/PageTitle'
import { DiscardButton, SaveButton } from '~/components/Buttons'
import { withForm } from '~/components/Form'
import { TemplateCard } from '~/components/FileUpload'
import { BackgroundSingleFileUpload } from '~/components/BackgroundFileUpload'
import * as NAV from '~/constants/nav-titles'
import * as API from '~/constants/api'
import { useGoogleEvent } from '~/components/GoogleAnalytics/GoogleAnalytics'

import UploadedFile from './UploadedFile'

function PicklistImportForm ({ title, form, isLoading, onSubscribe }) {
  const { handleSubmit } = form
  const { sendEvent } = useGoogleEvent()
  const formState = useFormState()

  return (
    <form onSubmit={handleSubmit}>
      <Container>
        <Header>
          <PageTitle
            pageTitle={title}
            parentTitle={NAV.PICKLISTS}
            rightButton={(
              <>
                <DiscardButton disabled={isLoading} />
                <SaveButton disabled={isLoading || (!formState.values.file)} />
              </>
            )}
          />
        </Header>

        <Content>
          <Grid container={true} spacing={3}>
            <Grid item={true} xs={12} lg={8}>
              <BackgroundSingleFileUpload
                name="file"
                api={API.PCIKLIST_FILE_VALIDATE}
                onSubscribe={onSubscribe}
                Component={UploadedFile}
              />
            </Grid>
            <Grid item={true} xs={12} lg={4}>
              <Grid container={true} spacing={3}>
                <Grid item={true} xs={12}>
                  <TemplateCard
                    fileName="Picking%20Bulk%20Upload.xlsx"
                    onClick={() => sendEvent({
                      eventAction: 'Template File Download Packing',
                      eventCategory: 'Packing'
                    })}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Container>
    </form>
  )
}

PicklistImportForm.propTypes = {
  form: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onSubscribe: PropTypes.func.isRequired
}

export default withForm(PicklistImportForm)
